{
    if(window.eHanlin === undefined || window.eHanlin === null){
        window.eHanlin = {}
    }
    if(window.eHanlin.platform_env === undefined || window.eHanlin.platform_env === null){
        window.eHanlin.platform_env = {}
        window.eHanlin.platform_env.cdn = 'https://ehanlin-web-public-resource.s3-ap-northeast-1.amazonaws.com'
    }
    const template = `
            <style>
                footer {
                    font-family: "Noto Sans TC", "Helvetica Neue", Arial, sans-serif; 
                    background-color: #0D6CBE;
                    -moz-user-select:none;
                    -webkit-user-select:none;
                    -ms-user-select:none;
                    user-select:none;
                }
                .footer-top {
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -ms-flex-pack: center;
                    justify-content: center;
                    padding: 24px 0;
                }
                .footer-bottom {
                    font-size: 12px;
                    text-align: center;
                    letter-spacing: 1px;
                    color: #fff;
                    padding-bottom: 24px;
                    
                }
                .footer-bottom > p {
                    margin: 0px 0px;
                }
                .footer-bottom > p:nth-child(2) {
                    margin-top: 6px;
                }
                .footer-bottom > p > span > a {
                    text-decoration: none;
                    color: white;
                    border-bottom: solid 1px white;
                }
                .item > ul { 
                    padding: 0;
                    margin: 0px 60px 0px 0px;
                }
                
                .item:last-child > ul { 
                    margin: 0px;
                }
                .icon {
                    margin-right: 8px;
                }
                .icon:nth-child(4) {
                    display: none;
                }
                .item > ul > li {
                    list-style: none;
                    text-align: center;
                    font-size: 12px;
                    line-height: 20px;
                    letter-spacing: 1px;
                    color: #fff;
                    margin-bottom: 12px;
                    
                }
                .item:nth-child(1) > ul > li{
                    text-align: left;
                }
                .item:nth-child(2) > ul > li{
                    text-align: left;
                }
                .item > ul > li > a{
                    text-decoration: none;
                    letter-spacing: 1px;
                    color: #fff;
                    
                }
                .footer-support {
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-pack: center;
                    -ms-flex-pack: center;
                    justify-content: center;
                    -webkit-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    background-color: #065DA7;
                    padding: 12px 0;
                }
                .footer-support,.footer-support a {
                    font-size: 12px;
                    text-align: center;
                    color: #fff
                }
                .footer-support .support-browser {
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -ms-flex-wrap: nowrap;
                    flex-wrap: nowrap;
                    margin-left: 12px;
                }
                .footer-support a {
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-pack: center;
                    -ms-flex-pack: center;
                    justify-content: center;
                    -webkit-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    text-decoration: none;
                }
                .footer-support a span {
                    margin-left: 6px;
                }
                
                .footer-support a:nth-child(n+2) {
                    margin-left: 12px;
                }
                
                .footer-support img {
                    height: 22px;
                }

                #eh-novice-board-toggle > a {
                    cursor: pointer
                }
                
                @media (max-width: 991px) {
                    .icon:nth-child(2) {
                        display: none;
                    }
                    .icon:nth-child(4) {
                        display: inline-block;
                    }
                }
                @media (max-width: 630px) {
                    .footer-top {
                        display:-webkit-box;
                        display: -ms-flexbox;
                        display: flex;
                        -webkit-box-pack: start;
                        -ms-flex-pack: start;
                        justify-content: flex-start;
                        -ms-flex-wrap: wrap;
                        flex-wrap: wrap;
                        padding: 24px 40px 0;
                    }
                    .item {
                        margin-bottom: 12px;
                    }
                    .item > ul { 
                        margin: 0px 0px 0px 0px;
                    }
                    .item:nth-child(-n+3) {
                        width: 100%;
                    }
                    .item:nth-child(n+3) {
                        width: 50%;
                        max-width: 132px;
                    }
                    .item:nth-child(n+3) > ul > li {
                        text-align: left;
                    }
                    .footer-bottom {
                        padding: 0 40px 24px;
                    }
                    .footer-bottom > p {
                        margin: 0px 0px;
                    }
                    .footer-bottom > p {
                        margin: 0px 0px;
                    }
                    .footer-bottom > p > span {
                        display: block;
                    }
                    .footer-support {
                        -webkit-box-orient: vertical;
                        -webkit-box-direction: normal;
                        -ms-flex-direction: column;
                        flex-direction: column;
                    }
                    .footer-support .support-browser {
                        margin-top: 6px;
                    }
                }
            </style>
            <footer>
                <div class="footer-top">
                    <div class="item">
                        <ul>
                            <li>客服專線</li>
                            <li><a href="tel:0282282575">02-82282575</a></li>
                            <li>
                                <a class="icon" href="https://www.facebook.com/ehanlin.com.tw/" target="_blank"><img src="${window.eHanlin.platform_env.cdn}/web/eh-footer/icon-fb.svg"></a>
                                <a class="icon" href="/event/line/?utm_source=website&utm_medium=button&utm_campaign=footer" target="_blank"><img src="${window.eHanlin.platform_env.cdn}/web/eh-footer/icon-line.svg"></a>
                                <a class="icon" href="https://www.instagram.com/ehanlin.tw/" target="_blank"><img src="${window.eHanlin.platform_env.cdn}/web/eh-footer/icon-ig.svg"></a>
                                <a class="icon" href="tel:0282282575"><img src="${window.eHanlin.platform_env.cdn}/web/eh-footer/icon-phone.svg"></a>
                            </li>
                        </ul>
                    </div>
                    <div class="item">
                        <ul>
                            <li>服務時間</li>
                            <li>星期一至五 | 9:00至21:00<br>星期六/日及國定假日 | 休息</li>
                        </ul>
                    </div>
                    <div class="item">
                        <ul>
                            <li>
                                <a href="/app/keyword/" onclick="ga('send', 'event', '首頁', 'click', '小中高知識點關鍵字');">小中高知識點關鍵字</a>
                            </li>
                            <li>
                                <a href="/infos/courseuse/" onclick="ga('send', 'event', '首頁', 'click', '課程使用說明');">課程使用方法</a>
                            </li>
                            <li>
                                <a href="/infos/learningnotify/?utm_source=mainpage&utm_medium=banner&utm_campaign=learningnotify" onclick="ga('send', 'event', '首頁', 'click', '學習通知');">LINE學習通知綁定</a>
                            </li>
                            <li id="eh-novice-board-toggle">
                                <a>新手教學</a>
                            </li>
                            <li>
                                <a href="/app/online-showcase/handout-list.html#JS&all&all" onclick="ga('send', 'event', '首頁', 'click', '講義加購');">講義加購</a>
                            </li>
                        </ul>
                    </div>
                    <div class="item">
                        <ul>
                            <li>
                                <a href="/infos/qa/">聯絡我們</a>
                            </li>
                            <li>
                                <a href="/infos/about/">關於我們</a>
                            </li>
                            <li>
                                <a href="/app/member-center/user-rank.html?utm_source=website&utm_medium=button&utm_campaign=footer" onclick="ga('send', 'event', '首頁', 'click', '會員等級說明');">會員等級說明</a>
                            </li>
                            <li >
                                <a href="/event/handout-errata/">勘誤啟事</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="footer-bottom">
                    <p>
                        <span>如欲購買雲端學院課程請至線上<a href="/app/online-showcase/product-list.html">課程購買</a>、</span> <span>前往各經銷據點或撥打客服專線</span>
                    </p>
                    <p>
                        <span>Copyright ⓒ 2013 eHanlin Inc.</span> <span>保留一切權利 <a href="/app/member-center/terms.html">使用條款</a>  <a href="/app/member-center/privacy.html">隱私權政策</a></span>
                    </p>
                </div>
                <div class="footer-support">
                    <span>本網站支援瀏覽器：</span>
                    <span class="support-browser">
                        <a href="https://www.google.com/intl/zh-TW/chrome/" target="_blank">
                            <img src="${window.eHanlin.platform_env.cdn}/web/eh-footer/icon-chrome.svg">
                            <span>Chrome</span></a>
                        <a href="https://www.microsoft.com/zh-tw/edge" target="_blank">
                            <img src="${window.eHanlin.platform_env.cdn}/web/eh-footer/icon-edge.svg">
                            <span>Edge</span></a>
                    </span>
                </div>
            </footer>
    `;
    customElements.define('eh-footer', class extends HTMLElement {
        constructor() {
            super();
            const shadowRoot = this.attachShadow({ mode: 'open' });
            shadowRoot.innerHTML = template;

            this.ehNoviceBoardInitial();
        }

        ehNoviceBoardInitial() {
            const ehNoviceBoardToggle = this.shadowRoot.querySelector('#eh-novice-board-toggle');
            ehNoviceBoardToggle.hidden = true;

            customElements.whenDefined('eh-novice-board').then(async () => {
                let ehNoviceBoardEl = document.querySelector('eh-novice-board');

                const ehNoviceBoard = customElements.get('eh-novice-board');

                const { eventNameList: ehNoviceBoardEventNameList } = ehNoviceBoard;
                
                if(!ehNoviceBoardEl) {
                    await new Promise((resolve) => {
                        ehNoviceBoard.on(ehNoviceBoardEventNameList.onDomLoaded, () => { 
                            ehNoviceBoardEl = document.querySelector('eh-novice-board');
                            resolve();
                        });
                    });
                }

                const ehNoviceBoardExisted = ehNoviceBoardEl != null;
                ehNoviceBoardToggle.hidden = !ehNoviceBoardExisted;

                ehNoviceBoardToggle.querySelector('a').onclick = () => {
                    EHNoviceBoard.setNoviceDisplay(true);
                    ehNoviceBoardEl.dispatchEvent(new Event('open'));
                }
            });
        }
    });
}
